import React, { useEffect, useRef, useState } from "react";
import { Layer, Marker, Source } from "react-map-gl/mapbox";
import * as turf from "@turf/turf";

const GpsPolygon = ({
  name,
  id,
  colour,
  coordinates_polygon,
  showLabel = true,
  geofenceDescription,
  setShowModal,
  geogroupId,
  geogroupName,
  setGeofenceEditPolygonInfo,
  permissionEdit
}) => {
  const [menu, setMenu] = useState({ visible: false, x: 0, y: 0 });
  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setMenu((prev) => ({ ...prev, visible: false }));
      }
    };

    if (menu.visible) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [menu.visible]);

  const toRing = (coords) => {
    if (!coords || !Array.isArray(coords) || coords.length < 3) return null;
    let ring;
    ring = coords.map((v) => [Number(v.longitude), Number(v.latitude)]);
    return ring;
  };

  const geofence = toRing(coordinates_polygon);
  if (!geofence) return null;

  const polygonGeoJSON = {
    type: "Feature",
    properties: { id: String(id), name },
    geometry: {
      type: "Polygon",
      coordinates: [geofence],
    },
  };

  const centroidGeofence = turf.centroid(polygonGeoJSON);

  const openSubMenu = (e, geoName) => {
    setMenu({ ...menu, visible: false });
    console.log("El nombre es: ", geoName);
    console.log("El componente es: ", e);
    setMenu({
      visible: true,
      x: e.clientX,
      y: e.clientY,
    });
  };

  const openEditModal = () => {
    console.log('Se debe procesar y abrir el modal de edicion')
    var aux_object = {
        selectedGeoGroup: { value: geogroupId, label: geogroupName},
        geofenceId: id,
        geofenceName: name,
        vertices: coordinates_polygon,
        description: geofenceDescription,
        
      }
    console.log(aux_object)
    setGeofenceEditPolygonInfo(aux_object)
    setShowModal()
     setMenu({ ...menu, visible: false });
  }
  const sourceId = `polygon-source-${String(id)}`;
  const fillLayerId = `polygon-fill-${String(id)}`;
  const lineLayerId = `polygon-line-${String(id)}`;
  const labelLayerId = `polygon-label-${String(id)}`;

  const fillLayer = {
    id: fillLayerId,
    type: "fill",
    paint: {
      "fill-color": colour || "#00A",
      "fill-opacity": 0.3,
    },
  };

  const lineLayer = {
    id: lineLayerId,
    type: "line",
    paint: {
      "line-color": colour || "#00A",
      "line-opacity": 0.7,
      "line-width": 2,
    },
  };

  const labelLayer = {
    id: labelLayerId,
    type: "symbol",
    layout: {
      "text-field": ["get", "name"], // toma la propiedad "name"
      "text-size": 14,
      "text-anchor": "center",
    },
    paint: {
      "text-color": "#000",
      "text-halo-color": "#fff", // borde blanco para que no se pierda
      "text-halo-width": 2,
    },
  };

  return (
    <Source id={sourceId} type="geojson" data={polygonGeoJSON}>
      <Layer {...fillLayer} />
      <Layer {...lineLayer} />
      {showLabel && (
        <Marker
          key={name}
          longitude={centroidGeofence.geometry.coordinates[0]}
          latitude={centroidGeofence.geometry.coordinates[1]}
        >
          <div
            onContextMenu={(e) => openSubMenu(e, name)}
            className="w-17 text-[9px] text-center bg-white bg-opacity-60 text-black rounded shadow px-1 py-1"
          >
            {name}
          </div>
        </Marker>
      )}
      {menu.visible && permissionEdit && (
        <div
          ref={menuRef}
          className="fixed bg-white border border-gray-300 p-1 shadow-md rounded-md hover:bg-gray-200 cursor-pointer transition"
          style={{
            top: menu.y,
            left: menu.x,
          }}
        >
          <div className="hover:bg-gray-200 cursor-pointer transition" onClick={openEditModal}>
            Edit Geofence
          </div>
        </div>
      )}
    </Source>
  );
};

export default GpsPolygon;
